import { Injectable, inject } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DefaultFilterEntriesSto, DefaultViewFilterSto } from 'src/app/shared/models/default-view-filter.model';
import { DsmApiResponseDataDto } from 'src/app/shared/models/dsm-api-call.model';
import { DsmApiCall } from 'src/app/shared/services/dsm-api-call.service';
import { environment } from 'src/environments/environment';
import { AcknowledgeRequestDto } from '../models/incoming-topic.model';

@Injectable({
  providedIn: 'root',
})
export class IncomingTopicsService {
  private serviceCall = inject(DsmApiCall);

  //-----------------------------------------------------------------------------------------------------------------
  /**
   *
   * @param rsqlFilter
   * @param relatedAggregateTypes
   * @param limit
   * @param offset
   * @returns
   */
  loadIncomingTopics(
    rsqlFilter: string | null,
    relatedAggregateTypes: string[] | null,
    limit: number,
    offset: number
  ): Observable<DsmApiResponseDataDto> {
    let url = environment.apiBaseUrl + '/v1/incoming-topics?limit=' + limit + '&offset=' + offset;

    let sep = '&';
    if (!!rsqlFilter && rsqlFilter.length > 0) {
      url += sep + 'filter=' + rsqlFilter;
      sep = '&';
    }

    if (!!relatedAggregateTypes && relatedAggregateTypes.length > 0) {
      url += sep + 'relatedAggregateTypes=' + relatedAggregateTypes.join(',');
    }

    return this.serviceCall.get(url).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }

  private _getRsqlString(filters: DefaultFilterEntriesSto): string | null {
    let rsql = '';

    const customerIds = filters?.getStringArrayFilter('customerIds');
    const machineIds = filters?.getStringArrayFilter('machineIds');
    const productFamilies = filters?.getStringArrayFilter('productFamilies');
    const status = filters?.getStringArrayFilter('status');
    const types = filters?.getStringArrayFilter('types');

    if (customerIds?.length) rsql += 'customerId=in=' + customerIds.join(',') + ';';
    if (machineIds?.length) rsql += 'machineId=in=' + machineIds.join(',') + ';';
    if (productFamilies?.length) rsql += 'machineProductFamily=in=' + productFamilies.join(',') + ';';
    if (status?.length) rsql += 'status=in=' + status.join(',') + ';';
    if (types?.length) rsql += 'topicType=in=' + types.join(',') + ';';

    return rsql?.trim().length > 0 ? rsql.substring(0, rsql.length - 1) : null;
  }

  /**
   *
   * @param viewFilter
   * @param relatedAggregateTypes
   * @param sort
   * @param offset
   * @returns
   */
  loadIncomingTopicsFiltered(
    viewFilter: DefaultViewFilterSto,
    relatedAggregateTypes: string[] | null,
    sort: Sort | null,
    offset: number
  ): Observable<DsmApiResponseDataDto> {
    const filters = viewFilter.getFilters();

    let url = environment.apiBaseUrl + '/v1/incoming-topics?limit=' + viewFilter.pageSize + '&offset=' + offset;
    if (!!relatedAggregateTypes && relatedAggregateTypes.length > 0) {
      url += '&relatedAggregateTypes=' + relatedAggregateTypes.join(',');
    }

    const rsql: string | null = this._getRsqlString(filters);
    if (rsql) url += '&filter=' + rsql;

    if (sort) {
      url += '&orderBy=' + sort.active + ':' + sort.direction;
    }

    const textFilter = filters.getFilter('text');
    if (!!textFilter && textFilter.length) {
      url += '&searchTerm=' + textFilter;
    }

    return this.serviceCall.get(url).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }

  //-----------------------------------------------------------------------------------------------------------------
  /**
   *
   */
  acknowledgeIncomingTopic(aggregateId: string, requestBody: AcknowledgeRequestDto): Observable<DsmApiResponseDataDto> {
    const url = environment.apiBaseUrl + '/v1/incoming-topics/' + aggregateId;
    return this.serviceCall.put(url, requestBody).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }
}
